import { useTranslation } from 'react-i18next';

const Minimal = () => {
  const { t } = useTranslation('common');

  return (
    <div className="gap-cove-25 flex items-center text-sm font-medium">
      <span>
        {t('money-back', {
          defaultValue: '60-Day Money-Back Guarantee',
        })}
      </span>
      <div className="bg-cove-navy-blue bottom-[1px] inline-block h-9 w-[1px] rounded-[2px]" />
      <span>{t('free-shipping', { defaultValue: 'Free Shipping' })}</span>
    </div>
  );
};

export default Minimal;
